import { Grid } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const EmployeeNameContainer = styled(Grid)({
  "&:hover": {
    cursor: "pointer",
  },
});

export const MainTableContainer = styled(Grid)(({ theme }) => ({
  "& .isWeekend": {
    backgroundColor: lighten(theme.palette.secondary.light, 0.9),
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },

  "& .isPublicHoliday": {
    backgroundColor: "pink",
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },
}));
